export const CONFIRMORDER_REQUEST = "CONFIRMORDER_REQUEST";
export const CONFIRMORDER_SUCCESS = "CONFIRMORDER_SUCCESS";
export const CONFIRMORDER_ERROR = "CONFIRMORDER_ERROR";
export const ORDERSTATUS_CLEAR = "ORDERSTATUS_CLEAR";
export const CONFIRMORDER_params = {
    key: process.env.VUE_APP_API_KEY
};

export const SIGNATURE_REQUEST = "SIGNATURE_REQUEST";
export const SIGNATURE_SUCCESS = "SIGNATURE_SUCCESS";
export const SIGNATURE_ERROR = "SIGNATURE_ERROR";
export const SIGNATURESTATUS_CLEAR = "SIGNATURESTATUS_CLEAR";
export const SIGNATURE_params = {
    key: process.env.VUE_APP_API_KEY
};